import React, { useState } from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import images from "../../themes/images"
import { baseUrlImg } from "../../config/api"
import ModulePopUpBack from "./ModulePopUpBack"
import NumPadForCost from "./NumPadForCost"
import NumPadForPhoneNumber from "./NumPadForPhoneNumber"
import { Form, Input, message } from "antd"
import PrintTicket from "shared-components/ModulePopUp/PrintTicket"
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal"
import ServiceSwiper from "./ServicesSwiper"
import CodiceFiscaleInput from "./CodiceFiscaleInput"
import QRCode from "react-qr-code"

const NewModulePopUp4 = (props) => {
  const {
    togglePopUp,
    setScannedBarcode,
    service,
    accountInfo,
    service_s,
    rechargeMobile,
    createGiftCard,
    buyExalogic,
    getRechargeMobileSim,
    getRechargeMobile,
    setRechargeMobile,
    setServiceS,
    setCompanyServices,
    getCustomVoucherReq,
    getAircash,
  } = props
  console.log(service_s)

  const [flipped, setFLipped] = useState(false)
  const [toPrint, setToPrint] = useState(false)
  const [confermaMsg, setConfermaMsg] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState("")
  const [customCost, setCustomCost] = useState("")
  const [serviceMobile, setServiceMobile] = useState(service)
  const [showNumPadCost, setShowNumPadCost] = useState(false)
  const [codFisInps, setCodFisInps] = useState("")
  const [wallet, setWallet] = useState("")
  const [code, setCode] = useState("")
  const [qrData, setQrData] = useState(null)
  const [showQrCode, setShowQrCode] = useState(false)

  console.log(serviceMobile)

  const hasPhoneNumber =
    serviceMobile?.type === "1" || serviceMobile?.type === "TOPUP"

  const cfServices =
    serviceMobile?.type === "F" ||
    // serviceMobile?.type === "Payment System" ||
    serviceMobile?.type === "betflag" ||
    serviceMobile?.type === "K" ||
    serviceMobile?.id === "AZLBTC000" ||
    serviceMobile?.id === "AZBTC000" ||
    serviceMobile?.type === "V" ||
    serviceMobile?.type === "Aircash"

  //Variable cost
  const canChangeCost =
    service.type === "exalogic" ||
    service.type === "Payment System" ||
    service.type === "betflag" ||
    service.type === "Aircash"

  //K type
  const showWalletField = serviceMobile.type === "K" || serviceMobile.type === "V"

  //T type
  const showCodeFields = serviceMobile.type === "T"

  //Variable cost but not exalogic
  const hasCostZero = service_s?.services?.some(
    (service) => parseInt(service.cost) === 0
  )

  const allServices = service_s?.services || []

  const isValidCodiceFiscale = (codFis) => {
    return (
      codFis.length === 16 &&
      /^[A-Z]{6}\d{2}[A-EHLMPRST]{1}\d{2}[A-Z]{1}\d{3}[A-Z]{1}$/.test(codFis)
    )
  }

  const handleSubmit = (service_id, service_type) => {
    const isSepafin = accountInfo.profile.hasSepafinCredentials

    if (cfServices && !isValidCodiceFiscale(codFisInps)) {
      message.error("Il Codice Fiscale non è valido.")
      return
    }

    if (canChangeCost) {
      //Exalogic
      if (service_type === "exalogic") {
        buyExalogic(
          service_s?.company?.id ?? null,
          service_id,
          customCost ? customCost : serviceMobile.cost,
          accountInfo.profile.username,
          codFisInps
        )
      }
      //Betflag Direct
      else if (service_type === "betflag") {
        getCustomVoucherReq(
          service_id,
          customCost ? customCost : serviceMobile.cost,
          codFisInps
        )
      } else if (service_type === "Aircash") {
        console.log("AIRCASH")
      } else {
        //Create gift card
        createGiftCard(
          customCost ? customCost : serviceMobile.cost,
          codFisInps,
          service_id
        )
      }
    } else {
      //E-Pay Recharge
      if (
        service_type === "TOPUP" ||
        service_type === "PIN" ||
        service_type === "POSA"
      ) {
        getRechargeMobileSim(
          service_id,
          phoneNumber,
          serviceMobile.cost,
          serviceMobile.ean,
          accountInfo.profile.id
        )
      } else {
        //Mr-Pay Recharge
        getRechargeMobile(
          service_id,
          hasPhoneNumber ? phoneNumber : null,
          null,
          isSepafin,
          accountInfo.profile.username,
          codFisInps,
          customCost ? customCost : serviceMobile.cost,
          showCodeFields ? code : null,
          wallet ? wallet : null
        )
      }
    }
  }

  const handlePrenota = () => {
    if (!serviceMobile) {
      alert("Missing data")
      return
    }

    const qrPayload = {
      service_id: serviceMobile.service_id,
      type: serviceMobile.type,
      cost: serviceMobile.cost,
      codice_fiscale: accountInfo.profile.codFisInps,
      phoneNumber: phoneNumber,
    }

    const qrString = JSON.stringify(qrPayload)

    setQrData(qrString)
    setShowQrCode(true)
  }

  return (
    <div
      className="modulePopUP modulePopUP1 telRechanrge"
      onClick={() => {
        if (!(rechargeMobile && toPrint)) {
          togglePopUp(false)
          setScannedBarcode(null)
          setRechargeMobile({})
          setServiceS([])
          setCompanyServices([])
          setServiceMobile([])
        }
      }}
    >
      <div className="flip-container">
        <div className={`flipper ${flipped ? "flipped" : ""}`}>
          <div className="front">
            <div
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
              className={`leftCol_Module Popup4 ${
                !hasPhoneNumber ? "has-img" : ""
              } ${showNumPadCost ? "has-custom-cost" : ""} ${
                cfServices ? " cf-input" : ""
              }  ${showWalletField ? " cf-input" : ""}`}
            >
              <div
                className={
                  "row" +
                  (cfServices || showCodeFields ? " cf-input-row" : "") +
                  (showWalletField ? " wallet-row" : "")
                }
                style={{
                  borderWidth: 5,
                  borderColor: serviceMobile.colorBg,
                  borderStyle: "solid",
                }}
              >
                <div className="Close">
                  <span
                    className="CloseButton"
                    onClick={() => {
                      togglePopUp(false)
                      setScannedBarcode(null)
                      setRechargeMobile({})
                      setServiceS([])
                      setCompanyServices([])
                      setServiceMobile([])
                    }}
                  >
                    <img src={images.close} alt="" />
                  </span>
                </div>
                <div className="info-icon">
                  <span onClick={() => setFLipped(!flipped)}>
                    <i className="fal fa-question-circle"></i>
                  </span>
                </div>
                <div className="Logo" style={{ background: serviceMobile.colorBg }}>
                  <div className="Logo--Help">
                    <img
                      src={`${baseUrlImg}/${
                        service.gallery
                          ? service.gallery.icon
                          : service.icon
                          ? service.icon
                          : "uncategorized/placeholder.jpg"
                      }`}
                      alt=""
                    />
                  </div>
                </div>

                {canChangeCost || hasCostZero || allServices.length === 0 ? (
                  showNumPadCost ? (
                    <NumPadForCost
                      customCost={customCost}
                      setCustomCost={setCustomCost}
                    />
                  ) : (
                    <div className={"GamingBanner "}>
                      <div
                        className="img"
                        alt={service_s?.service_id}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <img
                          style={{
                            width:
                              service.background || service.gallery ? "100%" : "50%",
                          }}
                          src={`${baseUrlImg}/${
                            service.gallery
                              ? service.gallery.background
                              : service.background
                              ? service.background
                              : service.icon
                          }`}
                          alt=""
                        />
                      </div>
                    </div>
                  )
                ) : hasPhoneNumber ? (
                  <NumPadForPhoneNumber
                    phoneNumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                  />
                ) : (
                  <div className={"GamingBanner "}>
                    <div
                      className="img"
                      alt={service_s?.service_id}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <img
                        style={{
                          width: service.background ? "100%" : "50%",
                        }}
                        src={
                          // XBOX Core
                          ["32430", "32431", "32432"].includes(
                            serviceMobile.service_id
                          )
                            ? `${baseUrlImg}/background/gamepass-core.jpeg`
                            : `${baseUrlImg}/${
                                service.background
                                  ? service.background
                                  : service.icon
                              }`
                        }
                        alt=""
                      />
                    </div>
                  </div>
                )}

                <ServiceSwiper
                  allServices={allServices}
                  serviceMobile={serviceMobile}
                  canChangeCost={canChangeCost}
                  hasCostZero={hasCostZero}
                  showNumPadCost={showNumPadCost}
                  setShowNumPadCost={setShowNumPadCost}
                  changeService={setServiceMobile}
                  setCustomCost={setCustomCost}
                />

                {cfServices && (
                  <CodiceFiscaleInput
                    codFisInps={codFisInps}
                    setCodFisInps={setCodFisInps}
                    isValidCodiceFiscale={isValidCodiceFiscale}
                  />
                )}

                {showWalletField && (
                  <div className="CodiceFiscale wallet-input-field">
                    <label>
                      Wallet <span>*</span>
                    </label>
                    <Form>
                      <Form.Item hasFeedback name="wallet">
                        <Input
                          onChange={(e) => setWallet(e.target.value)}
                          placeholder="Inserisci Wallet"
                        />
                      </Form.Item>
                    </Form>
                  </div>
                )}

                {showCodeFields && (
                  <div className="CodiceFiscale wallet-input-field">
                    <label>
                      Scansiona Codice <span>*</span>
                    </label>
                    <Form>
                      <Form.Item hasFeedback name="wallet">
                        <Input
                          onChange={(e) => setCode(e.target.value)}
                          placeholder="Scansiona Codice"
                          suffix={
                            <i
                              className="fal fa-barcode-read"
                              style={{ cursor: "pointer" }}
                            />
                          }
                        />
                      </Form.Item>
                    </Form>
                  </div>
                )}

                <h5
                  className="service-name"
                  style={{
                    background:
                      serviceMobile.colorBg && serviceMobile.colorBg !== "#ffffff"
                        ? serviceMobile.colorBg
                        : "var(--accent-bg)",
                    color:
                      serviceMobile.colorTesto &&
                      serviceMobile.colorTesto !== "#ffffff"
                        ? serviceMobile.colorTesto
                        : "#ffff",
                  }}
                >
                  {serviceMobile.name
                    .replace(/PTR IT/g, "")
                    .replace(/(\d+)mo/g, "$1 mesi")
                    .trim()}
                </h5>

                <div className="Confimation Buttons">
                  <span
                    className="stampCup annulla"
                    onClick={() => {
                      togglePopUp(false)
                      setScannedBarcode(null)
                    }}
                  >
                    <h3>Annulla </h3>
                    <i className="fal fa-close" />
                  </span>

                  <span className="stampCup prenota" onClick={handlePrenota}>
                    <h3>Prenota </h3>
                    <i className="fal fa-qrcode" />
                  </span>

                  <span
                    className="stampCup esegui"
                    onClick={() => {
                      if (accountInfo?.token) {
                        if (serviceMobile.type === 1) {
                          handleSubmit(serviceMobile.service_id, serviceMobile.type)

                          setToPrint(true)
                        } else {
                          setConfermaMsg(true)
                        }
                      } else {
                        window.location.hash = "login"
                        togglePopUp(false)
                        setToPrint(true)
                      }
                    }}
                  >
                    <h3>Esegui </h3>
                    <i className="fal fa-check" />
                  </span>
                </div>

                <ConfirmationModal
                  messageVisible={confermaMsg}
                  cost={customCost ? customCost : serviceMobile.cost}
                  onConfirm={() => {
                    handleSubmit(
                      serviceMobile.service_id
                        ? serviceMobile.service_id
                        : serviceMobile.id,
                      serviceMobile.type
                    )
                    setToPrint(true)
                    setConfermaMsg(false)
                  }}
                  onCancel={() => setConfermaMsg(false)}
                />

                {qrData ? (
                  <div className="messages">
                    <div className="closeM" onClick={() => setQrData(null)}>
                      chiudi QR code
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ fontSize: 19, fontWeight: 400, color: "red" }}>
                        Prenotazione eseguita con successo!
                      </p>
                      <p style={{ marginBottom: 5 }}>
                        Ricarica: <b>{serviceMobile.name}</b>
                      </p>
                      {phoneNumber && (
                        <p style={{ marginBottom: 5 }}>
                          Tel: <b>{phoneNumber}</b>
                        </p>
                      )}
                      {codFisInps && (
                        <p style={{ marginBottom: 5 }}>
                          Codice Fiscale: <b>{codFisInps}</b>
                        </p>
                      )}

                      <QRCode value={qrData} size={150} style={{ marginTop: 10 }} />
                    </div>
                  </div>
                ) : (
                  (rechargeMobile?.errors || rechargeMobile?.message) && (
                    <div className="messages">
                      <div className="closeM" onClick={() => setRechargeMobile({})}>
                        chiudi messaggi
                      </div>
                      {rechargeMobile?.errors ? (
                        Object.keys(rechargeMobile?.errors).map((item, index) => (
                          <div className="errorM" key={index}>
                            <i className="fad fa-exclamation text-danger"></i>
                            {rechargeMobile?.errors[item]}
                          </div>
                        ))
                      ) : (
                        <div className="infoM">
                          <i className="fad fa-info text-info"></i>{" "}
                          {rechargeMobile?.message}
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          {flipped && service_s && (
            <div className="back">
              <ModulePopUpBack
                service_s={service_s}
                handleFlip={() => setFLipped(!flipped)}
                hasPhoneNumber={hasPhoneNumber}
                showNumPadCost={showNumPadCost}
                cfServices={cfServices}
              />
            </div>
          )}

          {rechargeMobile && toPrint && (
            <PrintTicket
              arr={rechargeMobile.return ? rechargeMobile.return : rechargeMobile}
              setPrint={setToPrint}
              scontrino={serviceMobile.content_scontrino}
            />
          )}
        </div>
      </div>
    </div>
  )
}

const mapsStateToProps = (state) => ({
  isShowing: state.main.isShowing,
  service_s: state.main.companyServices,
  rechargeMobile: state.auth.rechargeMobile,
  skinExtras: state.auth.skinExtras,
  accountInfo: state.auth.accountInfo,
  scannedBarcode: state.auth.scannedBarcode,
})

export default connect(mapsStateToProps, { ...MainActions, ...AuthActions })(
  NewModulePopUp4
)
